import { Component } from '@angular/core';
import { MatDialogActions, MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-unverified-customer-for-auto-payment-dialog',
  styleUrls: ['./unverified-customer-for-auto-payment-dialog.component.scss'],
  templateUrl: './unverified-customer-for-auto-payment-dialog.component.html',
  imports: [MatDialogModule, MatDialogActions]
})
export class UnverifiedCustomerForAutoPaymentDialogComponent {
  constructor() {}
}
